import { queryOptions, useQuery } from '@tanstack/react-query';

import { productsApi } from '../api/products-api';

import { productKeys } from './product-keys';

export function productQueryOptions(productId: string) {
  return queryOptions({
    queryKey: productKeys.detail(productId),
    queryFn: () => productsApi.get(productId),
  });
}

/** Null before the product exists. */
export function useProduct(productId: string | null) {
  return useQuery({ ...productQueryOptions(productId ?? ''), enabled: productId !== null });
}
